import { Component, Input, OnInit } from '@angular/core';
import { SharedUsers } from 'app/model/shared_user';
import { SharedUser } from 'app/model/user';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { catchError, combineLatest, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { RESTArray } from '../../angular-rest';

@Component({
	selector: 'app-condividi',
	templateUrl: './condividi.html',
	styleUrls: ['./../impostazioni_agenda.css']
})

export class ShareComponent implements OnInit {
	@Input() utentiAgenda: RESTArray<SharedUser>;
	contatti: Observable<SharedUser[]>;
	private searchName = new BehaviorSubject<string>(null);

	constructor(private availableUsers$: SharedUsers) { }

	// TODO: Get utenti è da fare in ngOnChange
	ngOnInit(): void {
		this.contatti = this.utentiAgenda.pipe(
			combineLatest(
				// FIXME: to RESTArray.
				this.availableUsers$,
				(utenti, contatti) => contatti.filter((c) =>
					!utenti.some(u => u.codice_fiscale === c.codice_fiscale)
				)
			),
			combineLatest(
				this.searchName.pipe(
					debounceTime(300),
					distinctUntilChanged()
				),
				(allUsers, search) => {
					return search ? allUsers.filter((user) =>
						user.nome.lastIndexOf(search) !== -1 ||
						user.cognome.lastIndexOf(search) !== -1 ||
						user.codice_fiscale.lastIndexOf(search) !== -1) : allUsers;
				}
			),
			// TODO: add real error handling
			catchError(error => Observable.of<SharedUser[]>([]))
		);
	}

	search(term: string): void {
		this.searchName.next(term);
	}

	addUser(user: SharedUser) {
		this.utentiAgenda.add(user);
	}

	deleteUser(user: SharedUser) {
		this.utentiAgenda.delete(user);
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/condividi/condividi.ts